export {getRootClassName} from './components/theme/getRootClassName';
